import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';

export const TransferCompleted: React.FC = (): React.ReactElement => {
  const tr = useTranslator();
  const navigate = useNavigate();

  const goToDashboard = React.useCallback((): void => {
    navigate('/home');
  }, [navigate]);

  return (
    <ApplicationModal
      variant="prominent"
      title={tr('WE_RECEIVED_PAYMENT_INITIATED')}
      description={tr('WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION')}
      onClose={goToDashboard}>
      <Button variant="dark" fullWidth={true} onClick={goToDashboard}>
        {tr('DONE')}
      </Button>
    </ApplicationModal>
  );
};
